"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _tristate_checkbox_with_label = _interopRequireDefault(require("./tristate_checkbox_with_label"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StackedTable = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(StackedTable, _React$Component);
  var _super = _createSuper(StackedTable);
  function StackedTable() {
    (0, _classCallCheck2["default"])(this, StackedTable);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(StackedTable, [{
    key: "render",
    value: function render() {
      var _this = this;
      return (
        /*#__PURE__*/
        // @ts-expect-error - TS2769 - No overload matches this call.
        React.createElement(List, {
          error: this.props.error,
          height: this.props.height
        }, this.props.options.map(function (optionGroupData) {
          return _this.renderGroup(optionGroupData);
        }))
      );
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(optionGroup) {
      var _this2 = this;
      var mode = this.props.mode;
      return /*#__PURE__*/React.createElement("div", {
        key: optionGroup.label,
        "data-provides": "stacked-table-group",
        "data-provides-for": optionGroup.label
      }, /*#__PURE__*/React.createElement(OptionGroup, null, optionGroup.label, mode === 'radio' && this.radioLabels()), optionGroup.options.map(function (option) {
        return _this2.renderOption(option);
      }));
    }
  }, {
    key: "radioLabels",
    value: function radioLabels() {
      var _this$props = this.props,
        radioOnText = _this$props.radioOnText,
        radioOffText = _this$props.radioOffText;
      return /*#__PURE__*/React.createElement(RadioLabels, null, /*#__PURE__*/React.createElement("span", null, radioOnText), /*#__PURE__*/React.createElement("span", null, radioOffText));
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var _this$props2 = this.props,
        toggleSelectedId = _this$props2.toggleSelectedId,
        selected = _this$props2.selected,
        mode = _this$props2.mode;
      // @ts-expect-error - TS2345 - Argument of type 'string | number' is not assignable to parameter of type 'string'.
      var optionSelected = selected.indexOf(option.value) >= 0;
      return /*#__PURE__*/React.createElement(Option, {
        key: option.value,
        "data-provides": "stacked-table-option",
        "data-provides-for": option.value
        // @ts-expect-error - TS2769 - No overload matches this call.
        ,
        highlight: optionSelected && mode === 'checkbox'
      }, mode === 'radio' && /*#__PURE__*/React.createElement(React.Fragment, null, option.label, option.note && /*#__PURE__*/React.createElement(Note, null, option.note)), mode === 'checkbox' && /*#__PURE__*/React.createElement(_tristate_checkbox_with_label["default"], {
        checkedState: optionSelected ? 'checked' : 'empty',
        type: "checkbox",
        name: option.value.toString(),
        onChange: function onChange() {
          return toggleSelectedId(option.value, !optionSelected);
        },
        label: /*#__PURE__*/React.createElement(React.Fragment, null, option.label, option.note && /*#__PURE__*/React.createElement(Note, null, option.note)),
        disabled: option.disabled
      }), mode === 'radio' && /*#__PURE__*/React.createElement(RadioButtons, null, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        checked: optionSelected,
        onChange: function onChange(_event) {
          return toggleSelectedId(option.value, true);
        },
        disabled: option.disabled
      }), /*#__PURE__*/React.createElement("input", {
        type: "radio",
        checked: !optionSelected,
        onChange: function onChange(_event) {
          return toggleSelectedId(option.value, false);
        },
        disabled: option.disabled
      })));
    }
  }]);
  return StackedTable;
}(React.Component);
(0, _defineProperty2["default"])(StackedTable, "defaultProps", {
  mode: 'checkbox',
  radioOnText: 'Show',
  radioOffText: 'Hide'
});
var List = _styledComponents["default"].div.withConfig({
  displayName: "stacked_table__List"
})(["margin-top:10px;border:1px solid ", " ", ";border-bottom:none;border-radius:2px;", " height:", ";overflow-y:auto;"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.error ? _constants.colors.darkRed : _constants.colors.lightGrey;
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.height || 'auto';
});
var OptionGroup = _styledComponents["default"].div.withConfig({
  displayName: "stacked_table__OptionGroup"
})(["background-color:", ";border-bottom:solid 1px ", ";padding:5px 15px;", ";font-size:12px;color:", ";position:sticky;top:0;"], _constants.colors.lightestGrey, _constants.colors.lightGrey, (0, _constants.fontWeight)('normal'), _constants.colors.darkGrey);
OptionGroup.displayName = 'OptionGroup';
var Option = _styledComponents["default"].label.withConfig({
  displayName: "stacked_table__Option"
})(["", ";border-bottom:solid 1px ", ";padding:10px 15px;min-height:46px;display:block;width:100%;box-sizing:border-box;", " background-color:", ";"], (0, _constants.fontWeight)('normal'), _constants.colors.lightGrey, /* @ts-expect-error Flow -> TS migration */'', function (_ref) {
  var highlight = _ref.highlight;
  return highlight ? _constants.colors.babyBlue : 'inherit';
});
Option.displayName = 'Option';
var Note = _styledComponents["default"].span.withConfig({
  displayName: "stacked_table__Note"
})(["font-size:12px;", ";color:", ";margin-left:5px;"], (0, _constants.fontWeight)('normal'), _constants.colors.darkGrey);
var RadioLabels = _styledComponents["default"].div.withConfig({
  displayName: "stacked_table__RadioLabels"
})(["float:right;span:first-child{margin-right:35px;}span:last-child{margin-right:25px;}"]);
var RadioButtons = _styledComponents["default"].div.withConfig({
  displayName: "stacked_table__RadioButtons"
})(["float:right;input:first-child{margin-right:50px;}input:last-child{margin-right:30px;}"]);